import moment from 'moment';

export const STATISTICS_MONTH_COUNT = 12;

export function defaultStatisticsRange(now = moment()) {
  const end = now.clone().startOf('month');
  const start = end.clone().subtract(STATISTICS_MONTH_COUNT - 1, 'months');

  return {
    start: start.toDate(),
    end: end.toDate(),
    startPeriod: start.format('YYYY-MM'),
    endPeriod: end.format('YYYY-MM'),
  };
}

export function toStatisticsPeriod(date: Date) {
  return moment(date).startOf('month').format('YYYY-MM');
}

export function isDefaultStatisticsRange(start: Date, end: Date, now = moment()) {
  const defaults = defaultStatisticsRange(now);
  return defaults.startPeriod === toStatisticsPeriod(start) && defaults.endPeriod === toStatisticsPeriod(end);
}
